// eslint-disable-next-line no-restricted-imports
import { Menu as MenuBase } from "@base-ui/react/menu";
import classNames from "classnames";
import { TriangleIcon } from "@icons";
import {
    MenuItemContent,
    menuItemClassName,
    renderRowWithTooltip,
} from "./MenuItemContent";
import { MenuPopup } from "./MenuPopup";
import type { MenuSubmenuProps } from "./Menu.types";
import itemStyles from "./MenuItem.module.scss";
import popupStyles from "./MenuPopup.module.scss";

/**
 * A row that opens a nested menu of `children` on hover or ArrowRight
 * (ArrowLeft and Escape close it). The nested popup sits flush on the
 * row's end edge with its first row level with the trigger row.
 */
export const MenuSubmenu = ({
    label,
    leading,
    description,
    children,
    disabled = false,
    disabledReason,
    classNames: slotClassNames,
    ref,
    "data-forced-state": forcedState,
}: MenuSubmenuProps) => (
    <MenuBase.SubmenuRoot>
        <MenuBase.SubmenuTrigger
            ref={ref}
            disabled={disabled}
            label={typeof label === "string" ? label : undefined}
            className={menuItemClassName({
                hasDescription: description != null,
                isDestructive: false,
                className: slotClassNames?.trigger,
            })}
            data-forced-state={forcedState}
            render={renderRowWithTooltip({
                isDisabled: disabled,
                disabledReason,
            })}
        >
            <MenuItemContent
                leading={leading}
                description={description}
                trailing={
                    <TriangleIcon
                        className={itemStyles.itemTriangle}
                        aria-hidden
                    />
                }
            >
                {label}
            </MenuItemContent>
        </MenuBase.SubmenuTrigger>
        {/* alignOffset -5: the nested popup's 1px border plus its 4px row inset. */}
        <MenuPopup
            side="inline-end"
            align="start"
            sideOffset={0}
            alignOffset={-5}
            classNames={{
                positioner: slotClassNames?.positioner,
                popup: classNames(
                    popupStyles.popupSubmenu,
                    slotClassNames?.popup,
                ),
            }}
        >
            {children}
        </MenuPopup>
    </MenuBase.SubmenuRoot>
);
